function VarCategoryModel({ id, variant, options }) {
  let obj = {};
  obj.id = id;
  obj.variant = variant;
  obj.options = options;
  return obj;
}

export default VarCategoryModel;
